/**
 * 모듈리스트 연필과 동일한 액션.
 * 결함 있으면 첫 결함 수정, 없으면 커버 IR 신규 등록.
 *
 * @param {object|null} row — flatRows 의 panel / panel_single
 * @returns {{ type: 'edit', defect: object } | { type: 'create', row: object } | null}
 */
export function resolveModuleListPencilAction(row) {
  if (!row || (row.kind !== 'panel' && row.kind !== 'panel_single')) {
    return null;
  }
  const defects = row.defects?.length ? row.defects : row.defect ? [row.defect] : [];
  const primary = defects.find(Boolean);
  if (primary) {
    return { type: 'edit', defect: primary };
  }
  return { type: 'create', row };
}
